import cTooltip from '#themes/default/default/components/tooltip/tooltip.js';

import template from './offerProduct.html' with { type: 'html' };

export default {
	name: 'COfferProduct',
	components: {
		cTooltip
	},
	props: {
		order: {
			type: Object,
			default: () => null
		},
		product: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		showFuturePrice() {
			const hasDifferentFuturePrice = this.product.futurePrice && this.product.price.street.unformatted !== this.product.futurePrice.street.unformatted;
			const hasAutoRenewal = this.selectedPayment && this.order && !(this.selectedPayment.isManualRenewal || this.order.hasManualRenewalProduct);
			const hasBusinessProduct = this.order.hasBusinessProduct;
			return this.theme.variables.hasFuturePrice && hasDifferentFuturePrice && hasAutoRenewal && !hasBusinessProduct;
		},
		showDisclaimer() {
			return this.$store.getters.showDisclaimer;
		}
	},
	template
};
